import { mqrApi } from 'redux/services/mqr'

import { AppLoader } from 'components/AppLoader'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'

import { Mqr } from 'models/mqr'

import { DocumentsList } from 'shared/ui'

import styles from './Details.module.scss'

interface DetailsProps {
  id: Mqr['id']
  onClose: () => void
}

export const Details = ({ id, onClose }: DetailsProps) => {
  const { data, isLoading, isSuccess, error } = mqrApi.useGetMqrByIdQuery(id)

  function renderValue(label: string, key: keyof Mqr) {
    if (data?.[key]) {
      return (
        <div className={styles.item}>
          <div className={styles.itemName}>{label}</div>
          <div className={styles.itemText}>{data?.[key]}</div>
        </div>
      )
    }
    return null
  }

  if (isLoading) return <AppLoader />

  if (isSuccess) {
    return (
      <>
        <AppModalHeader onClose={onClose} title={`${data.name}`} />
        <div className={styles.container}>
          {renderValue('Наименование предприятия', 'name')}
          {renderValue('Наименование торговой точки', 'name_point')}
          {renderValue('Адрес торговой точки', 'point_address')}
          {renderValue('Количество QR', 'count_qr')}
          {renderValue('Ответ', 'customfield_14725')}
          {renderValue('Комментарий', 'description')}
          {renderValue('JIRA', 'jira_key')}
          {data.consultant && (
            <div className={styles.item}>
              <div className={styles.itemName}>Консультант</div>
              <div className={styles.itemText}>
                {data.consultant?.full_name}
              </div>
            </div>
          )}
          {renderValue('Статус', 'get_status_display')}

          <DocumentsList list={data.other_documents} />
        </div>
      </>
    )
  }

  return <code>{JSON.stringify(error)}</code>
}
